import React, { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { usePortalAuth } from "@/contexts/PortalAuthContext";
import { Loader2 } from "lucide-react";

export default function PortalLoginPage() {
  const { login, customer, loading } = usePortalAuth();
  const [email, setEmail] = useState(""); const [password, setPassword] = useState(""); const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (!loading && customer) return <Navigate to="/portal/" replace />;
  const submit = async (e) => { e.preventDefault(); setErr(""); setBusy(true); const r = await login(email, password); setBusy(false); if (r.ok) nav("/portal/"); else setErr(r.error); };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFB] p-6">
      <form onSubmit={submit} className="ky-card w-full max-w-md p-8" data-testid="portal-login-form">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-[#0F172A] flex items-center justify-center text-white font-bold text-sm">KY</div>
          <div><div className="text-xs text-[#94A3B8] uppercase tracking-wider font-semibold">Kamil Yıldırım</div><div className="font-semibold">Müşteri Portalı</div></div>
        </div>
        <h2 className="text-xl font-bold">Hesabınıza giriş yapın</h2>
        <p className="text-sm text-[#64748B] mt-1">Aldığınız hizmetlerin durumunu takip edin.</p>
        <div className="mt-6 space-y-3">
          <div><label className="block text-xs font-medium text-[#64748B] mb-1.5">E-posta</label><input data-testid="portal-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="ky-input"/></div>
          <div><label className="block text-xs font-medium text-[#64748B] mb-1.5">Şifre</label><input data-testid="portal-password" required type="password" value={password} onChange={e=>setPassword(e.target.value)} className="ky-input"/></div>
          {err && <div className="text-sm px-3 py-2 rounded-md bg-[#FEF2F2] text-[#DC2626] border border-[#FECACA]" data-testid="portal-login-error">{err}</div>}
          <button type="submit" disabled={busy} className="ky-btn ky-btn-accent w-full h-10" data-testid="portal-submit">{busy && <Loader2 size={14} className="animate-spin"/>}Giriş yap</button>
          <div className="text-xs pt-3 border-t border-[#ECECEF]"><Link to="/login" className="ky-link">Ekip üyesi misiniz? Buradan giriş yapın →</Link></div>
        </div>
      </form>
    </div>
  );
}
